import { jsx, Fragment } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { usePDFContent } from './PDF.js';
import RowPage from './RowPage.js';

const RowPageList = ({ root, width }) => {
  const { pdf, isReady } = usePDFContent();
  const pdfPages = useMemo(() => Array.from(Array(pdf?.numPages ?? 0).keys()), [
    pdf
  ]);
  if (!isReady) return null;
  return /* @__PURE__ */ jsx(Fragment, {
    children: pdfPages.map((index) => /* @__PURE__ */ jsx(RowPage, {
      pageNumber: index + 1,
      width,
      root
    }, index + 1))
  });
};

export { RowPageList as default };
//# sourceMappingURL=RowPageList.js.map
